// 📁 components/StreetView/StreetViewHeader.jsx
import { X, ExternalLink, MapPin } from 'lucide-react';
import { hexToRgba } from "../../utils/couleurs.js";

const StreetViewHeader = ({ 
  id, 
  nyme, 
  imageAdress, 
  address, 
  bgColor,
  onOpenInGoogleMaps, 
  onClose 
}) => (
  <div className="streetview-header"
  style={{ backgroundColor: hexToRgba(bgColor,1) }}
  >
    <div className="streetview-title-section">
      {id && (
        <div className="streetview-thumbnail">
          <img
            src={`${process.env.PUBLIC_URL}/images_compress/thumbs/${id}`}
            alt={nyme || "Miniature"}
            loading="eager"
          />
        </div>
      )}
      <div className="streetview-title-text">
        {nyme && (
          <h3 className="streetview-house-name">{nyme.toUpperCase()}</h3>
        )}
        {imageAdress && (
          <p className="streetview-address-source">
            <MapPin size={14} />
            {imageAdress}
          </p>
        )}
        {address && (
          <p className="streetview-address">
            <MapPin size={14} />
            {address}
          </p>
        )}
      </div>
    </div>
    
    <div className="streetview-actions">
      <button
        className="streetview-btn streetview-external-btn"
        onClick={onOpenInGoogleMaps}
        title="Ouvrir dans Google Maps"
        aria-label="Ouvrir dans Google Maps"
      >
        <ExternalLink size={16} />
        <span>Google Maps</span>
      </button>
      
      <button
        className="streetview-btn streetview-close-btn"
        onClick={onClose}
        aria-label="Fermer la modale"
      >
        <X size={20} />
      </button>
    </div>
  </div>
);

export default StreetViewHeader;